// extracted by mini-css-extract-plugin
export default {"arrow":"SlideArrow_arrow__YeddD","left":"SlideArrow_left__Y+s81","right":"SlideArrow_right__ECP1k"};